import React from "react";
import { Form } from "react-bootstrap";
import ReactQuill from "react-quill";
import { modules } from "../../constants/reactQuill";

function EndingSection({ endingItem, onChangeScheduleItem }) {
  return (
    <div>
      <Form.Group>
        <label>Ending Title</label>
        <Form.Control
          value={endingItem?.title || ""}
          placeholder="Ending Title"
          type="string"
          onChange={(event) =>
            onChangeScheduleItem(event.target.value, "title", "ending")
          }
        />
      </Form.Group>
      <Form.Group>
        <label>Ending Description</label>
        <ReactQuill
          key={`ending-description-${endingItem?._id || "new"}`}
          value={endingItem?.description || ""}
          onChange={(value) => {
            if (value === "<p><br></p>" || value === "<p></p>")
              onChangeScheduleItem("", "description", "ending");
            else onChangeScheduleItem(value, "description", "ending");
          }}
          modules={modules}
        />
      </Form.Group>
      <Form.Group>
        <label>Lesson Text</label>
        <ReactQuill
          key={`ending-lessonText-${endingItem?._id || "new"}`}
          value={endingItem?.lessonText || ""}
          onChange={(value) => {
            if (value === "<p><br></p>" || value === "<p></p>")
              onChangeScheduleItem("", "lessonText", "ending");
            else onChangeScheduleItem(value, "lessonText", "ending");
          }}
          modules={modules}
        />
      </Form.Group>{" "}
    </div>
  );
}

export default EndingSection;
